// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__29aD7","content":"Consent_content__3ed6e","footer":"Consent_footer__3GZAy"};